import config from 'config'
import grooveAPI from './api'

const groove = grooveAPI(config.api_url, config.api_concurrency)

export default groove
export { GrooveAPI } from './api'
